import { memo, Fragment } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

const SEVEN_IMG = 'https://wver.sprintstaticdata.com/v230/static/front/img/trape-seven.png';

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}
function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}
function findByNat(sub, nat) {
  return sub.find((s) => s.nat === nat);
}
function bookOf(exposures, nat) {
  return roundBook(exposures?.[nat] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// 1 CARD ONE-DAY — table teen1oneday. teen1day layout: Player/Dealer back-lay
// (left/right), phir 7 up/down boxes (up-box=DOWN, down-box=UP, seven img beech
// me). Mobile pe upar yellow Player/Dealer labels. book-black hamesha. img CDN se.
const BetTableTeen1 = memo(function BetTableTeen1({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const player = findByNat(sub, 'Player');
  const dealer = findByNat(sub, 'Dealer');
  const upPlayer = findByNat(sub, '7 Up Player');
  const downPlayer = findByNat(sub, '7 Down Player');
  const upDealer = findByNat(sub, '7 Up Dealer');
  const downDealer = findByNat(sub, '7 Down Dealer');

  const nameBook = (nat) => {
    const v = bookOf(exposures, nat);
    return <div className="float-right"><span className={`mr-2 ${bookCls(v)}`}>{fmtBook(v)}</span></div>;
  };

  const udBook = (item) => {
    const v = bookOf(exposures, item?.nat);
    return <div className={`up-down-book ${bookCls(v)}`}>{fmtBook(v)}</div>;
  };

  // 7 up/down columns — har box apne EXACT nat se map, suspend ussi nat ke
  // gstatus se. ≥768px layout (phone wala PHONE_COLS niche): Player: 7 Down Player | 7 | 7 Up
  // Player, Dealer: 7 Down Dealer | 7 | 7 Up Dealer. up-box=DOWN, down-box=UP
  // (class positional hai, label alag). Book: desktop pe DOWN left, UP right;
  // desktop se chhote pe locked box ki book side ke bahar wale kinare pe:
  // Player → left, Dealer → right (lockBook, CSS media query).
  const UD_COLS = [
    {
      side: 'teen1dayleft',
      label: 'Player',
      lockBook: 'lock-book-left',
      boxes: [
        { boxCls: 'up-box', nat: '7 Down Player', align: 'text-right', label: 'DOWN' },
        { boxCls: 'down-box', nat: '7 Up Player', align: 'text-left', label: 'UP' },
      ],
    },
    {
      side: 'teen1dayright',
      label: 'Dealer',
      lockBook: 'lock-book-right',
      boxes: [
        { boxCls: 'up-box', nat: '7 Down Dealer', align: 'text-right', label: 'DOWN' },
        { boxCls: 'down-box', nat: '7 Up Dealer', align: 'text-left', label: 'UP' },
      ],
    },
  ];

  // Phone (≤767px, reference `d-none-big`): grouped by UP / DOWN, not by side.
  // Left column both UP (Player box left, Dealer box right) + the ONLY seven;
  // right column both DOWN, no seven. Same as the player site.
  const PHONE_COLS = [
    {
      side: 'teen1dayleft',
      seven: true,
      boxes: [
        { boxCls: 'up-box', nat: '7 Up Player', align: 'text-right', label: 'UP' },
        { boxCls: 'down-box', nat: '7 Up Dealer', align: 'text-left', label: 'UP' },
      ],
    },
    {
      side: 'teen1dayright',
      seven: false,
      boxes: [
        { boxCls: 'up-box', nat: '7 Down Player', align: 'text-right', label: 'DOWN' },
        { boxCls: 'down-box', nat: '7 Down Dealer', align: 'text-left', label: 'DOWN' },
      ],
    },
  ];

  const renderUdBox = (box, lockBook) => {
    const item = findByNat(sub, box.nat);
    return (
      <div
        key={box.nat}
        className={`${box.boxCls}${suspCls(item)}${isSusp(item) && lockBook ? ` ${lockBook}` : ''}`}
        onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
      >
        {udBook(item)}
        {' '}
        <div className={box.align}>
          <div className="up-down-odds">{item?.b || 0}</div>
          <span>{box.label}</span>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Main: Player vs Dealer */}
      <div className="teen1daycasino-container">
        <div className="teen1dayleft">
          <div className="casino-box-row">
            <div className="casino-nation-name">
              <b>Player</b>
              {' '}
              {nameBook('Player')}
            </div>
            {' '}
            <div className="casino-bl-box">
              <div
                className={`back casino-bl-box-item${suspCls(player)}`}
                onClick={isSusp(player) ? undefined : () => handleBet(player.sid, 'back', player.b, player)}
              >
                <span className="casino-box-odd">{player?.b || 0}</span>
              </div>
              {' '}
              <div
                className={`lay casino-bl-box-item${suspCls(player)}`}
                onClick={isSusp(player) ? undefined : () => handleBet(player.sid, 'lay', player.l, player)}
              >
                <span className="casino-box-odd">{player?.l || 0}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="teen1daycenter"></div>
        <div className="teen1dayright">
          <div className="casino-box-row">
            <div className="casino-nation-name">
              <b>Dealer</b>
              {' '}
              {nameBook('Dealer')}
            </div>
            {' '}
            <div className="casino-bl-box">
              <div
                className={`back casino-bl-box-item${suspCls(dealer)}`}
                onClick={isSusp(dealer) ? undefined : () => handleBet(dealer.sid, 'back', dealer.b, dealer)}
              >
                <span className="casino-box-odd">{dealer?.b || 0}</span>
              </div>
              {' '}
              <div
                className={`lay casino-bl-box-item${suspCls(dealer)}`}
                onClick={isSusp(dealer) ? undefined : () => handleBet(dealer.sid, 'lay', dealer.l, dealer)}
              >
                <span className="casino-box-odd">{dealer?.l || 0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 7 Up/Down — PHONE (≤767px): Player / Dealer headers, UP column with
          the one seven, DOWN column without. Phone book sits on the box's own
          outer edge by default (up-box left, down-box right), so no lockBook. */}
      <div className="teen1daycasino-container d-none-big">
        <div className="teen1dayleft w-50"><b className="text-yellow">Player</b></div>
        <div className="teen1dayright w-50 text-right"><b className="text-yellow">Dealer</b></div>
        {PHONE_COLS.map((col, ci) => (
          <Fragment key={col.side}>
            <div className={col.side}>
              <div className="seven-up-down-box">
                {col.boxes.map((box) => renderUdBox(box, null))}
                {col.seven && (
                  <>
                    {' '}
                    <div className="seven-box">
                      <img src={SEVEN_IMG} />
                    </div>
                  </>
                )}
              </div>
            </div>
            {ci === 0 && <div className="teen1daycenter"></div>}
          </Fragment>
        ))}
      </div>

      {/* 7 Up/Down — ≥768px (reference `d-none-small`): one column per side,
          DOWN | 7 | UP, both with seven. Player/Dealer labels only below
          desktop width (columns may stack). */}
      <div className="teen1daycasino-container d-none-small">
        {UD_COLS.map((col, ci) => (
          <Fragment key={col.side}>
            <div className={col.side}>
              <div className={`d-none-desktop${ci === 1 ? ' text-right' : ''}`}>
                <b className="text-yellow">{col.label}</b>
              </div>
              <div className="seven-up-down-box">
                {col.boxes.map((box) => renderUdBox(box, col.lockBook))}
                {' '}
                <div className="seven-box">
                  <img src={SEVEN_IMG} />
                </div>
              </div>
            </div>
            {ci === 0 && <div className="teen1daycenter"></div>}
          </Fragment>
        ))}
      </div>
    </>
  );
});

export default BetTableTeen1;
